// extracted by mini-css-extract-plugin
module.exports = {"svgImageContainer":"SvgImg_svgImageContainer_Fh5m0","svgImageContainer__image":"SvgImg_svgImageContainer__image_w_tvK"};